export const LaneFormProperties = {
  ID: 'id',
  DESCRIPTION: 'description',
  GEOMETRY: 'geometry',
  LANE_DIRECTION: 'laneDirection',
  TRAVEL_DIRECTION: 'travelDirection',
};
